<template>
    <div>
        <div class="d-flex justify-content-between p-4">
            <div class="col-2 pl-0 pr-0 d-md-flex">
                <div>
                    <span class=" proximanova text-nowrap fontsize14 black">Analytics Report</span>
                </div>
                <div class="d-md-flex justify-content-center pt-1">
                    <div
                        class="fontsize10 black80 text-nowrap proximanova mt-1 pillbtn mr-2 ml-0 ml-md-3 mr-lg-3 p-1 pointer"
                        :class="{'blue':selectedTab == 'video_visit'}"
                        id="posts_tab"
                        @click="changePillBtnColour('video_visit')">Video Visits</div>
                    <div
                        class="fontsize10 black80 proximanova pillbtn mr-2 mt-1 mr-lg-3 p-1 pointer"
                        :class="{'blue':selectedTab == 'video_viewed'}"
                        id="posts_tab"
                        @click="changePillBtnColour('video_viewed')">Viewed %</div>
                </div>
            </div>
            <div class="d-flex justify-content-end mt-2 mt-md-0">
                <!-- <span class="proximanova black60 fontsize10 pt-2">{{fromDate}} to {{toDate}}</span>      -->
                <div class="ml-md-2 d-md-flex">
                    <a  class="btn button-create btn-color mr-2 " v-popover:foo  id="search">
                        <span class="proximanova black60 fontsize10 my-auto">{{selectedStatusCode}}</span>
                        <img src="../../assets/Dropdown.svg" alt="dropdown" class="img-fluid p-2" />
                        <!-- <popover name="foo" class="profileStrengthpop" id="menu">
                            <div v-for="(option,index) in selectOptions" :key="index" class="p-2">                            
                                <span class="proximanova fontsize12 black80" 
                                :class="{'proximanova-semibold': option === selectedStatusCode}"
                                @click="selectedStatusCode = option">{{option}}</span>
                                <hr class="profhoriz">
                            </div>
                        </popover> -->
                        <date-range-picker
                            ref="picker"
                            opens="left"
                            :locale-data="locale"
                            :ranges="ranges"
                            v-model="dateRange"
                            @update="getchartData"                          
                        ></date-range-picker>  
                    </a>               
                </div>
            </div>
            
        </div>
        <div v-if="selectedTab === 'video_visit'" >
            <div v-if="chartData.length > 0 && entitlements.videoVisit === 'Y'">
                <highcharts  class="hc" :options="chartOptions"></highcharts>
            </div>
            <div v-else class="text-center p-4 pb-5">
                <span class="proximanova-semibold fontsize14 black" v-if="entitlements.videoVisit === 'Y'">No chart data available between selected dates</span>
                <span class="proximanova-semibold fontsize14 black" v-else>Please Subscribe to any Plan to view the information</span>
            </div>
        </div>
        <div v-if="selectedTab === 'video_viewed'">
            <video-viewed :dateSelectionObject="dateSelectionObject"></video-viewed>
        </div>
    </div>
</template>
<script>
 import DateRangePicker from 'vue2-daterange-picker'
import VideoViewed from './VideoViewed.vue'
import moment from 'moment'
import httpuserprofile from '../../js/http-userprofile.js'
import sessionUtils from '@/js/session-util.js'
import { bus } from "../../main";
export default{
    components:{
        VideoViewed,
        DateRangePicker
    },
    data(){
        return{
            entitlements : {},
            currentUserProfileId : null,
            selectOptions: ['Last 7 Days','15 Days','30 Days','3 Months','6 Months','12 Months','Custom Range'],
            selectedStatusCode: 'Last 7 Days',
            fromDate: '25 may, 2021',
            toDate: '31 may, 2021',
            selectedTab: 'video_visit',
            dateRange: {
                startDate: '2021-06-01',
                endDate: '2021-08-12',
            },
            dateSelectionObject : {
                fromDate : '2021-06-01',
                toDate : '2021-08-12',
                profileId : null,
            },
            series: [],
            locale: {
                direction: 'rtr',
                format: 'mm/dd/yyyy',
                separator: ' - ',
                applyLabel: 'Apply',
                cancelLabel: 'Cancel',
                weekLabel: 'W',
                customRangeLabel: 'Custom Range',
                daysOfWeek: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                monthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                firstDay: 0
            },
            ranges: { //default value for ranges object (if you set this to false ranges will no be rendered)
                'Last 7 Days': [],
                '15 Days': [],
                '30 Days': [],
                '3 Months': [],
                '6 Months': [],
                '12 Months': [],
            },
            chartData: [],
            chartOptions: {
                chart: {
                    type: 'areaspline'
                },               
                title: {
                    text: ''
                },
                legend: {
                    enabled:false
                },
        
                xAxis: {
                    gridLineWidth: 1,
                    visible: true,
                    categories:  ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'],
                    lineColor:'#007AFF',     
                },   
                yAxis: {
                    gridLineWidth: 1,
                    // min: 0,
                    // max:300,
                    title: {
                        text: ' '
                    },
                    plotLines: [ {
                        // value: 142,
                        color: '#007AFF',
                        dashStyle: 'shortdash',
                        width: 2,
                        label: {
                            text: ''
                        }
                    }]
                },
                tooltip: {
                    enabled:false
                },
                credits: {
                    enabled: false
                },
                plotOptions: {
                    column: {
                        stacking: 'percent',
                        pointPadding: 0.2,
                        borderWidth: 0,
                        pointWidth: 15
                    }
                },  
                series: [ {
                    name: 'Jane',
                    color: '#d1e7ff',
                    lineColor:'#007AFF',   
                    lineWidth: 1,         
                    marker: {
                        fillColor: 'white',
                        lineWidth: 1,
                        lineColor: '#007AFF'
                    },
                    data: this.chartData,             
                }]
            },
        }
    },
    mounted(){
        this.entitlements = JSON.parse(localStorage.getItem('entitlements'))
        this.currentUserProfileId = sessionUtils.getUserProfileId();
        this.dateSelectionObject.profileId = sessionUtils.getUserProfileId();
        this.getchartData();
    },
    watch:{
        chartData(){this.redraw()},
    },
    methods:{
        changePillBtnColour(type){
            this.selectedTab = type;
            // if(this.selectedTab === 'video_viewed'){
            //     var fromDate = moment(this.dateRange.startDate).format('yyyy-MM-DD');
            //     var toDate =   moment(this.dateRange.endDate).format('yyyy-MM-DD');
            //     let dataObj = {
            //         fromDate : fromDate,
            //         toDate : toDate,
            //         profileId : this.$session.get("profile_id")
            //     }
            //     bus.$emit('sendDataToVideoViewed', dataObj);
            // }
        },
        //fetching chart data between selecetd dates
        getchartData(){   
            console.log('entre into get chart data')       
            var fromDate = moment(this.dateRange.startDate).format('yyyy-MM-DD');
            var toDate =   moment(this.dateRange.endDate).format('yyyy-MM-DD');
            this.dateSelectionObject.fromDate = fromDate;
            this.dateSelectionObject.toDate = toDate;
            if(this.selectedTab === 'video_visit'){
                httpuserprofile.get("/userprofile/videoProfileViewedChartData?profileId="+sessionUtils.getUserProfileId()+"&fromDate="+fromDate+"&toDate="+toDate)
                .then((response) => {
                    console.log(response)
                    if(response.data.list === null || response.data.list === undefined){
                        this.chartData = []
                    }
                    if(response.data.list){
                        this.chartData = response.data.list;
                        console.log(this.chartData)
                    }             
                });
            }else{
                let dataObj = {
                    fromDate : fromDate,
                    toDate : toDate,
                    profileId : sessionUtils.getUserProfileId()
                }
                bus.$emit('sendDataToVideoViewed', dataObj);
            }
            
        },
         redraw(){   
            var that = this;     
            this.chartOptions.series[0].data = this.chartData.map(function (point) {
                return [point.createdatetimestamp, point.count]
            })
            this.chartOptions.xAxis.categories = []
            this.chartData.forEach((point) =>{
                let x = point.createdatetimestamp
                that.chartOptions.xAxis.categories.push(x)
            });
            var hightPeak = 0;
            this.chartData.forEach((point) =>{
                let y = point.count
                if(hightPeak <= y) {
                    hightPeak = y
                }
            });
            this.chartOptions.yAxis.plotLines[0].value = hightPeak
        console.log(this.chartOptions.yAxis.plotLines[0])
        },
    }

}
</script>
<style scoped>
@import '../../css/vue2-daterange-picker.css';
.form-control{
    height: unset !important;
    font-size: 12px;
}
.form-control:focus{
   border: none;
}
.btn-color{
  border-color: #D9DCE1;
  padding: 0px 1px
}
.dropdown-position-bottom.profileStrengthpop {
    z-index: 3 !important;
    color: rgba(31,31,31,1)  !important;
    font-size: 12px !important;
    top: 50px !important;
    font-weight: 500;
    width: 150px !important;
    left: unset !important;
    transform: translate3d(-35%,0px,0px);
  }
 .vue-popover.dropdown-position-bottom.profileStrengthpop:before {
    display: none !important;
  }
 .profhoriz {
  margin-top: .25em;
  margin-bottom: .25em;
  margin-left: 15px;
  margin-right: 15px;
  border-top: 1.5px solid rgba(0,0,0,.1);
  opacity:0.4
}
.pillbtn {
  cursor: pointer;
  border: 1px solid #dbdbdb;
  border-radius: 5px;
  height: 25px;
  width: 65px;
  text-align: center;
}
.hc{
    height: 220px;
    width: 100%;
    zoom:1;
}
.highcharts-button, .highcharts-legend, .highcharts-container > svg > text {display: none;}
</style>
